import React, { useCallback } from 'react';
import * as Styles from './ServerList.styles';
import { useDispatch, useSelector } from 'react-redux';
import { advancedHostingActions } from '@/redux/modules/advancedHosting';
import { Skeleton, IconChevronUpDown, IconChevronV3 } from 'gatorcomponents';

import { locale as routesLocale } from '@/utils/locale';
import useLocale from '@/hooks/useLocale';

import { useHistory } from 'react-router';
import ServerListItem from './components/ServerListItem';

const ServerList = ({
  servers,
  loading,
  sortField,
  sortOrder,
  onSort,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const lastListParams = useSelector(state => state.advancedHosting?.list?.lastListParams);

  const { productDetails: productDetailsLocale } = useLocale();
  const { advancedHosting: advancedHostingLocale } = productDetailsLocale || {};
  const { serverList: serverListLocale } = advancedHostingLocale || {};

  const mountLoading = () => (
    Array.from({ length: 10 }).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Skeleton key={index} width="100%" height="80px" />
    ))
  );

  const renderSortIcon = (field) => {
    if (sortField !== field) return <IconChevronUpDown size="sm" color="lowMedium" />;
    if (sortOrder === 'asc') return <IconChevronV3 size="sm" direction="top" color="lowMedium" />;
    return <IconChevronV3 size="sm" direction="bottom" color="lowMedium" />;
  };

  const handleGoToManagement = (serverId) => {
    history.push(`${routesLocale('routes.products')}${routesLocale('routes.productdetail')}/${serverId}`);
  };

  const handleServerUpdateSuccess = useCallback(() => {
    dispatch(advancedHostingActions.list.request(lastListParams || {}));
  }, [dispatch, lastListParams]);

  const handleUpdateNickname = (serverId, nickName) => {
    dispatch(advancedHostingActions.updateServer.request({
      serverId,
      nickName,
      onSuccess: handleServerUpdateSuccess,
    }));
  };

  const handleSortClick = () => {
    onSort('productName');
  };

  return (
    <Styles.Wrapper data-testid="advanced-hosting-server-list">
      <Styles.Header>
        <Styles.HeaderCell>
          <Styles.HeaderCellContent $clickable onClick={handleSortClick} data-testid="server-list-sort-details">
            {serverListLocale?.columnsLabel?.details}
            {renderSortIcon('productName')}
          </Styles.HeaderCellContent>
        </Styles.HeaderCell>
        <Styles.HeaderCell data-testid="server-list-header-ip">
          <Styles.HeaderCellContent>
            {serverListLocale?.columnsLabel?.addressIp}
          </Styles.HeaderCellContent>
        </Styles.HeaderCell>
        <Styles.HeaderCell data-testid="server-list-header-status">
          <Styles.HeaderCellContent>
            {serverListLocale?.columnsLabel?.status}
          </Styles.HeaderCellContent>
        </Styles.HeaderCell>
        <Styles.HeaderCell data-testid="server-list-header-quick-access">
          <Styles.HeaderCellContent>
            {serverListLocale?.columnsLabel?.quickAccess}
          </Styles.HeaderCellContent>
        </Styles.HeaderCell>
        <Styles.HeaderCell />
      </Styles.Header>

      <Styles.List>
        {loading ? (
          mountLoading()
        ) : (
          servers?.map(server => (
            <ServerListItem
              key={server.id}
              server={server}
              onGoToManagement={handleGoToManagement}
              onUpdateNickname={handleUpdateNickname}
              onFavoriteUpdateSuccess={handleServerUpdateSuccess}
            />
          ))
        )}
      </Styles.List>
    </Styles.Wrapper>
  );
};

export default ServerList;
ServerList.displayName = 'ServerList';
